import "./memberlist.css";
import * as React from "react";
import Table from "@mui/material/Table";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import DateFilter from "./DateFilter.jsx";

import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from '../Includes/Header';
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import { Card, Button, Grid, TextField, Avatar, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, IconButton, Menu, ListItemIcon, ListSubheader, Divider, Stack, TablePagination, Chip } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import SpaIcon from "@mui/icons-material/Spa"; // Import an appropriate icon
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link } from 'react-router-dom';
import {
  retrieveGymMember,
  AutocompleteMember,
  StatusMember,
  DeleteJoinMember,
} from "../Apihelper/MemberApiHelpr";
import {
  UseSteambath,
  CreateSteambath,
} from "../Apihelper/SteambathHelper.js";

import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";


import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { ThemeProvider, useTheme as useMuiTheme } from '@mui/material/styles';
import AppToast from '../../components/Toast/AppToast';
import PayButton from "../../components/PayButton/PayButton";
import MemberQuickView from "../../components/MemberQuickView/MemberQuickView";

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;
const PAGE_SIZE = 20;

function pickServerMemberTotal(res) {
  const v =
    res?.total_count ??
    res?.total_records ??
    res?.total ??
    res?.total_member ??
    res?.recordsFiltered ??
    res?.recordsTotal;
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: 16,
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: '#f0f7ff',
    transition: 'background-color 0.3s ease',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
  },
  background: 'linear-gradient(to right bottom, #ffffff, #f8fafc)',
}));

const SearchTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    '& fieldset': {
      borderColor: '#e2e8f0',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const MobileCard = styled(Card)(({ theme }) => ({
  margin: '8px 0',
  borderRadius: '12px',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  overflow: 'hidden',
  '&:hover': {
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
  },
}));

const MobileCardContent = styled(Box)({
  padding: '16px',
});

const MobileCardHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '12px',
});

const MobileCardActions = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderTop: '1px solid #e2e8f0',
  padding: '12px 16px',
  backgroundColor: '#f8fafc',
});

function MemberList(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { colors: appColors } = useAppTheme();
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dateRef = useRef();
  const [age, setAge] = React.useState('');
  const [status, setstatus] = useState('');
  const [openAvatarPopup, setOpenAvatarPopup] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState('');
  const searchQuery = location.state?.searchQuery || "";
  const exactMemberId = location.state?.memberId ?? null;
  const exactMemberIdRef = useRef(exactMemberId);
  const pageOptionIdMapRef = useRef({});
  const [searchInputValue, setSearchInputValue] = useState(searchQuery);
  const [statusFilter, setStatusFilter] = useState(location.state?.statusFilter ?? null);
  const statusFilterRef = useRef(location.state?.statusFilter ?? null);
  const initialJoinRange = (location.state?.joinFrom && location.state?.joinTo)
    ? { from: location.state.joinFrom, to: location.state.joinTo }
    : null;
  const [joinRange, setJoinRange] = useState(initialJoinRange);
  const joinRangeRef = useRef(initialJoinRange);
  const joinRangeLabel = location.state?.joinRangeLabel || '';
  const handleAvatarClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setOpenAvatarPopup(true);
  };
  
  const handleCloseAvatarPopup = () => {
    setOpenAvatarPopup(false);
    setSelectedImage('');
  };
  
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [actionMenuRow, setActionMenuRow] = useState(null);
  const [confirmUseBathOpen, setConfirmUseBathOpen] = useState(false);
  const [confirmUseBathPayload, setConfirmUseBathPayload] = useState(null);
  const [steamBathInfoOpen, setSteamBathInfoOpen] = useState(false);
  const [steamBathInfoRow, setSteamBathInfoRow] = useState(null);
  const [localrole] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userdata"))?.role || "";
    } catch {
      return "";
    }
  });

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  const handleToggle = (id,status) => {
    setOpenConfirmation(true);
   const newStatus = status === 1 ? 0 : 1;
  setstatus(newStatus);
  setDeleteConfirmationId(id);
  setIsActive(newStatus === 0);

  };

  const handleConfirm = async() => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
     
      
        const res = await StatusMember(userToken,userId,status, deleteConfirmationId);

        if (res.code == "200") {
            handleSnackbarOpen(res.message, 'success');
            setIsActive(!isActive);
            setOpenConfirmation(false);
          //  setOpenDeleteConfirmation(false);
            fetchData();
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
 
 

 
  const drawer = (
    <div className="d-flex flex-column h-100">
      <Header />
    </div>
  );
 
 
  const [options, setOptions] = useState([]);
  const [fetchdatarow, setetchdatarow] = useState([]); 
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [SearchText, setSearchText] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
  const [page, setPage] = useState(0);
  const [quickRow, setQuickRow] = useState(null); // member shown in the quick-view side panel
  const [quickWidth, setQuickWidth] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE);
  const rowsPerPageRef = useRef(PAGE_SIZE);
  const [totalCount, setTotalCount] = useState(0);
  const pageRef = useRef(0);
  const lastSearchRef = useRef('');
  const open = Boolean(anchorEl);
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Autocomplete shows "Name | ID | phone | email"; retrive-member API should receive only the name
  const searchTextForApi = (val) => {
    if (!val || typeof val !== "string") return val || "";
    const s = val.trim();
    const pipeIdx = s.indexOf("|");
    return pipeIdx !== -1 ? s.slice(0, pipeIdx).trim() : s;
  };

  const fetchMembersAt = async (pageZero, searchUpdate) => {
    setLoading(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      if (searchUpdate !== undefined) {
        lastSearchRef.current = searchTextForApi(searchUpdate);
      }
      const searchText = lastSearchRef.current;
      const limit = rowsPerPageRef.current;
      const index = pageZero * limit;
      // Only honors the exact-member jump on the single fetch it was meant for —
      // consumed here so any later search/pagination falls back to normal text search.
      const exactId = exactMemberIdRef.current;
      exactMemberIdRef.current = null;
      const res = await retrieveGymMember(userToken, userId, searchText, limit, index, statusFilterRef.current, joinRangeRef.current, exactId);
      const rows = res.code == "200" && Array.isArray(res.data) ? res.data : [];

      if (res.code == "200") {
        if (rows.length === 0 && pageZero > 0) {
          const prev = pageZero - 1;
          setTotalCount(Math.max(0, prev * limit));
          await fetchMembersAt(prev, undefined);
          return;
        }
        setetchdatarow(rows);
        setPage(pageZero);
        pageRef.current = pageZero;
        const serverTotal = pickServerMemberTotal(res);
        if (serverTotal != null) {
          setTotalCount(serverTotal);
        } else if (rows.length < limit) {
          setTotalCount(pageZero * limit + rows.length);
        } else {
          setTotalCount((prev) => Math.max(prev, (pageZero + 1) * limit + 1));
        }
      } else {
        setetchdatarow([]);
        setTotalCount(0);
        setPage(0);
        pageRef.current = 0;
      }
    } catch (error) {
      console.error(error);
      setetchdatarow([]);
      setTotalCount(0);
      handleSnackbarOpen('Failed to load members', 'error');
    } finally {
      setLoading(false);
    }
  };

  /** New search → page 0. No args → same page (after mutations). */
  const fetchData = (...args) => {
    if (args.length === 0) {
      return fetchMembersAt(pageRef.current, undefined);
    }
    return fetchMembersAt(0, args[0]);
  };

  const handleChangePage = (_event, newPage) => {
    fetchMembersAt(newPage, undefined);
  };

  useEffect(() => {
    exactMemberIdRef.current = location.state?.memberId ?? null;
    fetchMembersAt(0, searchQuery);
    setSearchInputValue(searchQuery);
  }, [searchQuery, location.state?.memberId]);

  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      navigate('/');
    }
  }, []);

  const handleSearchChange = (event, value) => {
    const searchText = value || '';
    setSearchInputValue(searchText);
    // Picking a suggestion should land on that exact member — never fall back
    // to a name-only search, which can match multiple same-named members.
    exactMemberIdRef.current = pageOptionIdMapRef.current[searchText] ?? null;
    fetchMembersAt(0, searchText);
  };


const handleInputChange = async (value) => {
  setSearchInputValue(value);
  if (value.length >= 3) {
  try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text

      const res = await AutocompleteMember(userToken, userId, searchText);

      if (res.code == "200") {
          const names = res.data.map(item => item.search_data);
          const idMap = {};
          res.data.forEach(item => { idMap[item.search_data] = item.id; });
          pageOptionIdMapRef.current = idMap;
          setOptions(names);
      } else {
          setOptions([]);
      }
  } catch (error) {
      console.error(error);
      // Handle errors
  }
}
};
const handleDelete = (id) => {
  handleClose();
  setDeleteConfirmationId(id);
  setOpenDeleteConfirmation(true,id);
};

const handleConfirmDelete =async (id) => {
  // setSnackbarMessage('package deleted successfully');
  // setSnackbarSeverity('error');
  // setOpenDeleteConfirmation(false);
  // setOpenToast(true); // Show toast message

  if (deleteConfirmationId !== null) {
   
      try {
          const userData = localStorage.getItem("userdata");
          const userDataObj = JSON.parse(userData);
          const userToken = userDataObj.token;
          const userId = userDataObj.id; 
       
        
          const res = await DeleteJoinMember(userToken, userId, deleteConfirmationId);
  
          if (res.code == "200") {
              handleSnackbarOpen(res.message, 'success');
              setOpenDeleteConfirmation(false);
              fetchData()
          } else {
              handleSnackbarOpen(res.message, 'error');
              //  console.error(error); // Handle error
          }
      } catch (error) {
          console.error(error);
          // Handle errors
      }
  }
  };


const handleCancelDelete = () => {
  setOpenDeleteConfirmation(false);
};

const handleCardPress = async (id) => {
  try {
    navigate('/memberdetails', {
      state: {
        id: id,
        random_no: Math.random(),
      },
    });
  } catch (error) {
    console.error("Error:", error);
  }
};
const [selectedMemberId, setSelectedMemberId] = useState(null);
const [steambath, setOpensteambath] = useState(false);
const [steambathvalue, setsteambathValue] = useState('');
const [steambathquantity, setSteambathQuantity] = useState("");
/** Dayjs value for steam bath payment date picker */
const [steambathPaymentDate, setSteambathPaymentDate] = useState(null);
const parsePaymentDateToDayjs = (paymentDate) => {
  if (paymentDate == null || paymentDate === "") return dayjs();
  const s = String(paymentDate).trim();
  const parts = s.split(/[-/]/);
  if (parts.length === 3) {
    const d = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10);
    const y = parseInt(parts[2], 10);
    if (!isNaN(d) && !isNaN(m) && !isNaN(y) && y > 31) {
      return dayjs(`${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`);
    }
  }
  const parsed = dayjs(s);
  return parsed.isValid() ? parsed : dayjs();
};
const handleOpensteambath = (memberId, paymentDate) => {
  setSelectedMemberId(memberId);
  setSteambathPaymentDate(parsePaymentDateToDayjs(paymentDate));
  setOpensteambath(true);
};
const handleClosesteambath = () => {
  setSteambathQuantity("");
  setsteambathValue("");
  setSteambathPaymentDate(null);
  setSelectedMemberId(null);
  setOpensteambath(false);
};

const handleChangeSteambathQuantity = (event) => {
  const inputValue = event.target.value;
  if (/^\d*$/.test(inputValue)) {
    setSteambathQuantity(inputValue);
  }
};

// Handle value change
const handleChangeSteambathValue = (event) => {
  const inputValue = event.target.value;
  if (/^\d*$/.test(inputValue)) {
    setsteambathValue(inputValue);
  }
};
// const handleSubmit = () => {
//   console.log("Submitted:", { quantity: steambathquantity, amount: steambathvalue });
//   handleClosesteambath();
// };
const handleSubmit = async () => {
  if (!selectedMemberId) {
    console.error("No member ID selected");
    return;
  }

  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const userId = userDataObj.id; // Assuming you have a userId in userdata
    const UseradminData = {
      member_id: selectedMemberId,
      quantity: steambathquantity,
      amount: steambathvalue,
      payment_date: steambathPaymentDate?.isValid()
        ? steambathPaymentDate.format("DD-MM-YYYY")
        : dayjs().format("DD-MM-YYYY"),
    };

    const response = await CreateSteambath(userToken, UseradminData);

   console.log(response);
    
    if (response.code == 200) {
      handleSnackbarOpen(response.message, 'success');
      handleClosesteambath();
      fetchData()
  }else {
      console.error("Failed to add steam bath:", response.message);
    }
  } catch (error) {
    console.error("API Error:", error.message);
  }
};
const handleUseBath = async (id) => {
  try {
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;
    const UseradminData = { member_id: id };
    const response = await UseSteambath(userToken, UseradminData);
    if (response.code == 200) {
      handleSnackbarOpen(response.message, "success");
      handleClosesteambath();
      fetchData();
      return true;
    }
    console.error("Failed to use steam bath:", response.message);
    return false;
  } catch (error) {
    console.error("API Error:", error.message);
    return false;
  }
};

const handleOpenActionMenu = (event, row) => {
  event.stopPropagation();
  setActionMenuAnchor(event.currentTarget);
  setActionMenuRow(row);
};
const handleCloseActionMenu = () => {
  setActionMenuAnchor(null);
  setActionMenuRow(null);
};

const openUseBathConfirmFromMenu = () => {
  if (!actionMenuRow) return;
  const r = actionMenuRow;
  setConfirmUseBathPayload({
    id: r.id,
    name: r.name,
    remaining: r.remaining_bath,
  });
  handleCloseActionMenu();
  setConfirmUseBathOpen(true);
};

const openSteamBathInfoModal = () => {
  if (!actionMenuRow) return;
  setSteamBathInfoRow(actionMenuRow);
  handleCloseActionMenu();
  setSteamBathInfoOpen(true);
};

const closeSteamBathInfoModal = () => {
  setSteamBathInfoOpen(false);
  setSteamBathInfoRow(null);
};

const handleConfirmUseBathProceed = async () => {
  if (!confirmUseBathPayload?.id) return;
  const ok = await handleUseBath(confirmUseBathPayload.id);
  if (ok) {
    setConfirmUseBathOpen(false);
    setConfirmUseBathPayload(null);
  }
};

  const theme = useMuiTheme(); // Active app theme (so nested ThemeProvider below doesn't shadow it with MUI defaults)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const renderMobileView = () => {
  return (
      <Box sx={{ p: 2 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress sx={{ color: appColors.leaf }} />
          </Box>
        ) : fetchdatarow.length === 0 ? (
          <Box sx={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            py: 6, px: 2, borderRadius: 2, backgroundColor: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}>
            <Typography variant="h6" sx={{ color: '#475569', fontWeight: 600, textAlign: 'center' }}>
              No members
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8', mt: 1, textAlign: 'center' }}>
              Add your first member using the New Member button
            </Typography>
          </Box>
        ) : (
          fetchdatarow.map((row) => (
            <MobileCard key={row.id ?? row.membership_number}>
              <MobileCardContent>
                <MobileCardHeader>
                  <Avatar
                    src={row.image}
                    alt={row.name}
                    sx={{
                      width: 50,
                      height: 50,
                      marginRight: 2,
                      border: `2px solid ${appColors.evergreen}`,
                    }}
                    onClick={() => handleAvatarClick(row.image)}
                  />
                  <Box>
                    <Typography variant="h6" sx={{ color: appColors.leaf, fontWeight: 'bold' }}>
                      {row.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ID: {row.membership_number}
                    </Typography>
                  </Box>
                </MobileCardHeader>

                <Grid container spacing={1} sx={{ mb: 2 }}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Phone
                    </Typography>
                    <Typography variant="body1">{row.phone}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Email
                    </Typography>
                    <Typography variant="body1">{row.email}</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Status
                    </Typography>
                    <Button
                      variant="outlined"
                      size="small"
                      sx={{
                        mt: 0.5,
                        fontWeight: 600,
                        textTransform: 'none',
                        borderColor: row.status === 1 ? '#059669' : '#dc2626',
                        color: row.status === 1 ? '#059669' : '#dc2626',
                      }}
                      onClick={() => handleToggle(row.id, row.status)}
                    >
                      {row.status === 1 ? 'Active' : 'Inactive'}
                    </Button>
                  </Grid>
                  {row.bath_available === "Yes" && (
                    <Grid item xs={6}>
                      <Typography variant="body2" color="text.secondary">
                        Remaining Baths
                      </Typography>
                      <Typography variant="body1" sx={{ color: '#059669', fontWeight: 600 }}>
                        {row.remaining_bath}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </MobileCardContent>

              <MobileCardActions sx={{ justifyContent: "flex-end" }}>
                <IconButton
                  size="small"
                  aria-label="Actions"
                  onClick={(e) => handleOpenActionMenu(e, row)}
                  sx={{ color: appColors.evergreen }}
                >
                  <MoreVertIcon />
                </IconButton>
              </MobileCardActions>
            </MobileCard>
          ))
        )}
      </Box>
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', height: '100vh', backgroundColor: "#EFEDF1" }}>
      <CssBaseline />
        <Box>
        <Header />
      </Box>
        <Box 
          component="main" 
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            padding: { xs: '10px', sm: '20px' },
            width: '100%',
            paddingRight: quickWidth ? `${quickWidth + 20}px` : undefined,
            transition: 'padding-right 0.2s ease',
          }}
        >
        <div style={{ display: 'flex', flexGrow: 1, marginTop: '50px' }}>
            <div style={{ flex: 1, marginTop: '15px', width: '100%' }}>
              <Box 
                sx={{ 
                  display: 'flex', 
                  flexDirection: { xs: 'column', sm: 'row' }, 
                  justifyContent: 'space-between',
                  gap: { xs: 2, sm: 0 },
                  mb: 3 
                }}
              >
                <Typography 
                  variant="h5" 
                  component="h6" 
                  sx={{ 
                    color: appColors.leaf,
                    fontWeight: 'bold',
                    fontSize: { xs: '1.25rem', sm: '1.5rem' }
                  }}
                >
                  Members
                </Typography>
                <Button 
                  variant="contained" 
                  onClick={() => navigate('/newmember')} 
                  sx={{ 
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                    fontWeight: 700,
                    backgroundColor: appColors.leaf,
                    '&:hover': {
                      backgroundColor: appColors.pine
                    }
                  }}
                >
                  New Member
                </Button>
              </Box>

              <Box 
                sx={{ 
                  display: 'flex', 
                  mb: 3,
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 2
                }}
              >
                <Autocomplete
                  freeSolo
                  id="free-solo-2-demo"
                  disableClearable
                  options={options}
                  inputValue={searchInputValue}
                  onInputChange={(event, value) => handleInputChange(value)}
                  onChange={(event, value) => handleSearchChange(event, value)}
                  sx={{ width: { xs: '100%', sm: 300 } }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: '#ffffff',
                          borderRadius: '8px',
                          '& fieldset': {
                            borderColor: 'rgba(31, 122, 84, 0.2)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'rgba(31, 122, 84, 0.3)',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: appColors.leaf,
                          }
                        }
                      }}
                      label="Search members"
                      InputProps={{
                        ...params.InputProps,
                        type: 'search',
                      }}
                    />
                  )}
                />
                <Stack direction="row" spacing={1} sx={{ alignSelf: 'center', flexWrap: 'wrap' }}>
                  {[{ label: 'All', value: null }, { label: 'Active', value: 1 }, { label: 'Inactive', value: 0 }].map((opt) => (
                    <Chip
                      key={opt.label}
                      label={opt.label}
                      onClick={() => {
                        statusFilterRef.current = opt.value;
                        setStatusFilter(opt.value);
                        fetchMembersAt(0, undefined);
                      }}
                      sx={{
                        fontWeight: 600,
                        cursor: 'pointer',
                        backgroundColor: statusFilter === opt.value
                          ? opt.value === 1 ? '#22c55e' : opt.value === 0 ? '#ef4444' : appColors.leaf
                          : '#e5e7eb',
                        color: statusFilter === opt.value ? '#fff' : '#374151',
                        '&:hover': {
                          backgroundColor: opt.value === 1 ? '#16a34a' : opt.value === 0 ? '#dc2626' : appColors.pine,
                          color: '#fff',
                        },
                      }}
                    />
                  ))}
                </Stack>
              </Box>

              {joinRange && (
                <Chip
                  label={`Showing: ${joinRangeLabel || 'New Joins'} — click to clear`}
                  onClick={() => {
                    joinRangeRef.current = null;
                    setJoinRange(null);
                    fetchMembersAt(0, undefined);
                  }}
                  onDelete={() => {
                    joinRangeRef.current = null;
                    setJoinRange(null);
                    fetchMembersAt(0, undefined);
                  }}
                  sx={{
                    fontWeight: 600,
                    cursor: 'pointer',
                    mb: 2,
                    backgroundColor: appColors.leafSoft,
                    color: appColors.evergreen,
                  }}
                />
              )}

              {isMobile ? renderMobileView() : (
                <TableContainer
                  component={Paper}
                  sx={{
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        overflowX: "auto",
        margin: "20px 0",
                  }}
                >
                  {loading ? (
        <div style={{ textAlign: 'center', margin: '50px auto' }}>
                      <CircularProgress sx={{ color: appColors.leaf }} />
        </div>
                  ) : fetchdatarow.length === 0 ? (
        <Box sx={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          py: 8, px: 2, backgroundColor: '#fafbfc', borderRadius: 1,
        }}>
          <Typography variant="h6" sx={{ color: '#475569', fontWeight: 600 }}>
            No members
          </Typography>
          <Typography variant="body2" sx={{ color: '#94a3b8', mt: 1 }}>
            Add your first member using the New Member button
          </Typography>
        </Box>
                  ) : (
              <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align="center">#</StyledTableCell>
                          <StyledTableCell>Membership Id</StyledTableCell>
                          <StyledTableCell align="left">Name</StyledTableCell>
                          <StyledTableCell align="left">Contact</StyledTableCell>
                          <StyledTableCell align="left">Status</StyledTableCell>
                          <StyledTableCell align="left">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                        {fetchdatarow.map((row, index) => (
                          <StyledTableRow key={row.id ?? row.membership_number ?? index}>
                            <TableCell align="center" sx={{ color: '#64748b', fontWeight: 500, minWidth: 40 }}>
                              {page * PAGE_SIZE + index + 1}
                            </TableCell>
                            <TableCell onClick={() => handleCardPress(row.id)}>
                              <Typography sx={{
                                color: appColors.leaf,
                                textDecoration: 'underline',
                                cursor: 'pointer'
                              }}>
                                {row.membership_number}
                              </Typography>
                      </TableCell>
                            <TableCell align="left">
                              <div style={{ display: 'flex', alignItems: 'center' }}>
               <Avatar 
                 src={row.image} 
                 alt={row.name} 
                                  sx={{ 
                                    marginRight: '10px', 
                                    cursor: 'pointer',
                                    border: `2px solid ${appColors.evergreen}` 
                                  }}
                                  onClick={() => handleAvatarClick(row.image)}
               />
               <span
                 style={{ cursor: 'pointer' }}
                 title="Quick view"
                 onClick={() => setQuickRow(row)}
               >
                 {row.name}
               </span>
                              </div>
                            </TableCell>
                            <TableCell align="left">
                              <Typography sx={{ fontSize: '0.875rem', color: appColors.leaf, fontWeight: 500 }}>
                                {row.phone}
                              </Typography>
                              <Typography sx={{ fontSize: '0.8rem', color: '#2C6E8F', fontWeight: 400 }}>
                                {row.email}
                              </Typography>
                            </TableCell>
                      <TableCell align="left">
                      <Button
                    variant="outlined"
                                sx={{
                                  fontWeight: 700,
                                  textTransform: 'none',
                                  borderColor: row.status === 1 ? '#059669' : '#dc2626',
                                  color: row.status === 1 ? '#059669' : '#dc2626',
                                  '&:hover': {
                                    borderColor: row.status === 1 ? '#047857' : '#b91c1c',
                                    backgroundColor: 'transparent'
                                  }
                                }}
                                onClick={() => handleToggle(row.id, row.status)}
                  >
                    {row.status === 1 ? 'Active' : 'Inactive'}
                  </Button>
                      </TableCell>
                            <TableCell align="center" sx={{ verticalAlign: "middle" }}>
                              <IconButton
                                size="small"
                                aria-label="Quick view"
                                title="Quick view"
                                onClick={() => setQuickRow(row)}
                                sx={{ color: appColors.evergreen }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                size="small"
                                aria-label="Actions"
                                onClick={(e) => handleOpenActionMenu(e, row)}
                                sx={{ color: appColors.evergreen }}
                              >
                                <MoreVertIcon />
                              </IconButton>
                            </TableCell>
                          </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
      )}
            </TableContainer>
              )}

              {!loading && totalCount > 0 && (
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[10, 20, 50]}
                  onRowsPerPageChange={(e) => {
                    const newSize = parseInt(e.target.value, 10);
                    rowsPerPageRef.current = newSize;
                    setRowsPerPage(newSize);
                    fetchMembersAt(0, undefined);
                  }}
                  showFirstButton
                  showLastButton
                  labelDisplayedRows={({ page: p, count }) =>
                    `Page ${p + 1} of ${Math.ceil(count / rowsPerPage)}  |  Total: ${count} records`
                  }
                  sx={{
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    borderRadius: { xs: 0, sm: '0 0 10px 10px' },
                    '& .MuiTablePagination-toolbar': {
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      gap: 1,
                      py: 1,
                    },
                  }}
                />
              )}
      </div>
          </div>
      </Box>

        <MemberQuickView
          member={quickRow}
          onClose={() => setQuickRow(null)}
          onOpenFull={handleCardPress}
          onWidthChange={setQuickWidth}
        />

        {/* Existing dialogs with updated styling */}
        <Dialog 
          open={openConfirmation} 
          onClose={handleCancel}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              padding: '16px'
            }
          }}
        >
          <DialogTitle sx={{ color: appColors.leaf, fontWeight: 'bold' }}>
            {isActive ? 'Deactivate' : 'Activate'}
          </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isActive
              ? 'Are you sure you want to deactivate this item?'
              : 'Are you sure you want to activate this item?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button 
              startIcon={<CancelIcon />}
              onClick={handleCancel}
              sx={{ 
                color: '#64748b',
                fontWeight: 'bold',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button 
              startIcon={<CheckCircleIcon />}
              onClick={handleConfirm}
              variant="contained"
              sx={{
                backgroundColor: appColors.leaf,
                fontWeight: 'bold',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: appColors.pine
                }
              }}
            >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

        <Dialog 
          open={openDeleteConfirmation} 
          onClose={handleCancelDelete}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              padding: '16px'
            }
          }}
        >
          <DialogTitle sx={{ color: '#dc2626', fontWeight: 'bold' }}>
            Delete Confirmation
          </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this Member?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
            <Button 
              startIcon={<CancelIcon />}
              onClick={handleCancelDelete}
              sx={{ 
                color: '#64748b',
                fontWeight: 'bold',
                textTransform: 'none'
              }}
            >
              Cancel
            </Button>
            <Button 
              startIcon={<DeleteIcon />}
              onClick={handleConfirmDelete}
              variant="contained"
              sx={{
                backgroundColor: '#dc2626',
                fontWeight: 'bold',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#b91c1c'
                }
              }}
            >
              Delete
            </Button>
      </DialogActions>
    </Dialog>

        <Menu
          anchorEl={actionMenuAnchor}
          open={Boolean(actionMenuAnchor)}
          onClose={handleCloseActionMenu}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          /* Avoid layout shift + horizontal jitter while Grow changes paper width each frame */
          disableScrollLock
          transitionDuration={0}
          slotProps={{
            paper: {
              sx: {
                minWidth: 240,
                maxWidth: "min(280px, calc(100vw - 24px))",
                borderRadius: 2,
                py: 0.5,
                boxSizing: "border-box",
              },
            },
          }}
        >
          {actionMenuRow?.bath_available === "Yes" &&
            actionMenuRow.remaining_bath != null &&
            actionMenuRow.remaining_bath !== "" && (
              <>
                <ListSubheader
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 700,
                    lineHeight: 1.4,
                    color: "#047857",
                    bgcolor: "rgba(5, 150, 105, 0.08)",
                    py: 1,
                    mb: 0.5,
                  }}
                >
                  Steam bath · {actionMenuRow.remaining_bath} remaining
                </ListSubheader>
                <Divider sx={{ my: 0.5 }} />
              </>
            )}
          <MenuItem
            onClick={() => {
              if (actionMenuRow) handleCardPress(actionMenuRow.id);
              handleCloseActionMenu();
            }}
          >
            <ListItemIcon>
              <VisibilityIcon fontSize="small" sx={{ color: appColors.evergreen }} />
            </ListItemIcon>
            View details
          </MenuItem>
          <MenuItem
            onClick={() => {
              if (actionMenuRow) {
                navigate("/newmember", {
                  state: { editMode: true, memberId: actionMenuRow.id, memberData: actionMenuRow },
                });
              }
              handleCloseActionMenu();
            }}
          >
            <ListItemIcon>
              <EditIcon fontSize="small" sx={{ color: appColors.evergreen }} />
            </ListItemIcon>
            Edit member
          </MenuItem>
          <MenuItem onClick={openSteamBathInfoModal}>
            <ListItemIcon>
              <InfoOutlinedIcon fontSize="small" sx={{ color: appColors.evergreen }} />
            </ListItemIcon>
            Steam bath info
          </MenuItem>
          {actionMenuRow?.bath_available === "Yes" ? (
            <MenuItem onClick={openUseBathConfirmFromMenu}>
              <ListItemIcon>
                <SpaIcon fontSize="small" sx={{ color: appColors.evergreen }} />
              </ListItemIcon>
              Use steam bath
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                if (actionMenuRow) {
                  handleOpensteambath(
                    actionMenuRow.id,
                    actionMenuRow.bath_payment_date ??
                      actionMenuRow.payment_date ??
                      actionMenuRow.steam_bath_payment_date
                  );
                }
                handleCloseActionMenu();
              }}
            >
              <ListItemIcon>
                <SpaIcon fontSize="small" sx={{ color: appColors.evergreen }} />
              </ListItemIcon>
              Add steam bath
            </MenuItem>
          )}
          {localrole === "admin" && (
            <MenuItem
              onClick={() => {
                if (actionMenuRow) handleDelete(actionMenuRow.id);
                handleCloseActionMenu();
              }}
              sx={{ color: "error.main" }}
            >
              <ListItemIcon>
                <DeleteIcon fontSize="small" color="error" />
              </ListItemIcon>
              Delete member
            </MenuItem>
          )}
        </Menu>

        <Dialog
          open={steamBathInfoOpen}
          onClose={closeSteamBathInfoModal}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: {
              borderRadius: "12px",
              maxHeight: "min(85vh, 520px)",
            },
          }}
        >
          <DialogTitle sx={{ color: appColors.evergreen, fontWeight: "bold", pb: 0.5 }}>
            Steam bath
            {steamBathInfoRow?.name ? (
              <Typography component="span" variant="body2" sx={{ display: "block", fontWeight: 400, color: "text.secondary", mt: 0.5 }}>
                {steamBathInfoRow.name} · {steamBathInfoRow.membership_number}
              </Typography>
            ) : null}
          </DialogTitle>
          <DialogContent dividers sx={{ pt: 2 }}>
            {steamBathInfoRow && (
              <>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 1.5,
                    mb: 2,
                    bgcolor: "rgba(31, 122, 84, 0.04)",
                    borderColor: "rgba(31, 122, 84, 0.15)",
                  }}
                >
                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
                    Profile summary
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 1 }}>
                    <Typography variant="body2">
                      <strong>Available:</strong>{" "}
                      {steamBathInfoRow.bath_available ?? "—"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Remaining:</strong>{" "}
                      {steamBathInfoRow.remaining_bath ?? "—"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Used (total):</strong>{" "}
                      {steamBathInfoRow.used_bath ?? "—"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Total baths:</strong>{" "}
                      {steamBathInfoRow.total_bath ?? "—"}
                    </Typography>
                  </Box>
                </Paper>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: appColors.evergreen, mb: 1 }}>
                  Package records
                </Typography>
                {Array.isArray(steamBathInfoRow.steam_baths) && steamBathInfoRow.steam_baths.length > 0 ? (
                  <Stack spacing={1.5}>
                    {steamBathInfoRow.steam_baths.map((pkg) => {
                      const total = Number(pkg.total_bath);
                      const used = Number(pkg.used_bath);
                      const remaining = Number.isFinite(total) && Number.isFinite(used) ? Math.max(0, total - used) : "—";
                      return (
                        <Paper
                          key={pkg.id ?? `${pkg.member_id}-${pkg.created_at}`}
                          variant="outlined"
                          sx={{
                            p: 1.5,
                            borderRadius: "10px",
                            borderColor: "rgba(5, 150, 105, 0.25)",
                            bgcolor: "rgba(5, 150, 105, 0.04)",
                          }}
                        >
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#047857" }}>
                            {pkg.package_name || "Steam bath"}
                          </Typography>
                          <Box sx={{ mt: 1, display: "grid", gap: 0.75 }}>
                            <Typography variant="body2">
                              <strong>Total / Used / Left:</strong>{" "}
                              {pkg.total_bath ?? "—"} / {pkg.used_bath ?? "—"} / {remaining}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Amount:</strong>{" "}
                              {pkg.amount != null && pkg.amount !== ""
                                ? `₹${Number(pkg.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
                                : "—"}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Payment date:</strong>{" "}
                              {pkg.payment_date
                                ? dayjs(pkg.payment_date).format("DD MMM YYYY")
                                : "—"}
                            </Typography>
                          </Box>
                        </Paper>
                      );
                    })}
                  </Stack>
                ) : (
                  <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                    No steam bath package records for this member.
                  </Typography>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 2, py: 1.5 }}>
            <Button
              onClick={closeSteamBathInfoModal}
              variant="contained"
              sx={{
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: appColors.evergreen,
                "&:hover": { backgroundColor: appColors.pine },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmUseBathOpen}
          onClose={() => {
            setConfirmUseBathOpen(false);
            setConfirmUseBathPayload(null);
          }}
          PaperProps={{ sx: { borderRadius: "12px", padding: "8px" } }}
        >
          <DialogTitle sx={{ color: appColors.evergreen, fontWeight: "bold" }}>
            Use steam bath?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {confirmUseBathPayload
                ? `This will use 1 steam bath for ${confirmUseBathPayload.name}.`
                : ""}
              {confirmUseBathPayload?.remaining != null && confirmUseBathPayload.remaining !== ""
                ? ` They have ${confirmUseBathPayload.remaining} bath(s) remaining.`
                : ""}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => {
                setConfirmUseBathOpen(false);
                setConfirmUseBathPayload(null);
              }}
              sx={{ textTransform: "none", fontWeight: 600, color: "#64748b" }}
            >
              Cancel
            </Button>
            <PayButton overlay
              variant="contained"
              onClick={handleConfirmUseBathProceed}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: appColors.evergreen,
                "&:hover": { backgroundColor: appColors.pine },
              }}
            >
              Confirm
            </PayButton>
          </DialogActions>
        </Dialog>

        <Dialog 
          open={openAvatarPopup} 
          onClose={handleCloseAvatarPopup}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              overflow: 'hidden'
            }
          }}
        >
          <DialogContent sx={{ padding: 0 }}>
            <img 
              src={selectedImage} 
              alt="avatar" 
              style={{ 
                width: '100%', 
                height: 'auto',
                display: 'block'
              }} 
            />
    </DialogContent>
  </Dialog>

        <Dialog 
          open={steambath} 
          onClose={handleClosesteambath}
          PaperProps={{
            sx: {
              borderRadius: '12px',
              padding: '16px'
            }
          }}
        >
          <DialogTitle sx={{ color: appColors.leaf, fontWeight: 'bold' }}>
            Add Steambath
          </DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Payment date"
            value={steambathPaymentDate}
            onChange={(v) => setSteambathPaymentDate(v)}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                margin: "dense",
                fullWidth: true,
                sx: {
                  mb: 1,
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#e2e8f0" },
                    "&:hover fieldset": { borderColor: appColors.evergreen },
                    "&.Mui-focused fieldset": { borderColor: appColors.evergreen },
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
        <TextField
          autoFocus
          margin="dense"
          label="Quantity"
          type="text"
          fullWidth
          variant="outlined"
          value={steambathquantity}
          onChange={handleChangeSteambathQuantity}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.leaf,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.leaf,
                  },
                }
              }}
        />
        <TextField
          margin="dense"
          label="Total Amount"
          type="text"
          fullWidth
          variant="outlined"
          value={steambathvalue}
          onChange={handleChangeSteambathValue}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.leaf,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.leaf,
                  },
                }
              }}
        />
      </DialogContent>
      <DialogActions>
            <Button 
              onClick={handleClosesteambath}
              sx={{ 
                color: '#64748b',
                fontWeight: 'bold',
                textTransform: 'none'
              }}
            >
              Clear
            </Button>
            <PayButton overlay 
              onClick={handleSubmit}
              variant="contained"
              sx={{
                backgroundColor: appColors.leaf,
                fontWeight: 'bold',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: appColors.pine
                }
              }}
            >
              Submit
            </PayButton>
      </DialogActions>
    </Dialog>

        <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
      </Box>
    </ThemeProvider>
  );
}

export default MemberList;